interface TextProps {
  type: string;
  sectionId: string;
  colorScheme: string;
  alignment: string;
  twoColumns: boolean;
  preTitle?: string;
  sectionTitle: string;
  titleUnderline: boolean;
  subtitle?: string;
  ctaPrimary?: any;
  ctaSecondary?: any;
  author?: string;
  quote?: string;
  body: any[];
  columnLeft?: any;
  columnRight?: any;
  image?: any;
  removeBottomPadding: boolean;
  imageShape?: string;
  paragraph?: string;
  cta?: any;
  textAlign?: string;
  title?: any;
}

const Text = ({ 
  type, 
  sectionId, 
  colorScheme, 
  alignment, 
  twoColumns, 
  preTitle, 
  sectionTitle, 
  titleUnderline, 
  subtitle, 
  ctaPrimary, 
  ctaSecondary, 
  author, 
  quote, 
  body = [], 
  columnLeft, 
  columnRight, 
  image, 
  removeBottomPadding, 
  imageShape,
  paragraph,
  cta,
  title,
  textAlign = 'left'
}) => {
  const normalizedData = {
    type,
    sectionId,
    colorScheme,
    alignment,
    twoColumns,
    preTitle,
    sectionTitle,
    titleUnderline,
    subtitle,
    ctaPrimary,
    ctaSecondary,
    author,
    quote,
    body,
    columnLeft,
    columnRight,
    image,
    removeBottomPadding,
    imageShape,
    paragraph,
    cta,
    title,
    textAlign
  }

  return normalizedData
}

export default Text
